import React from 'react';
import PropTypes from 'prop-types';

import { kebabCase } from 'lodash';
import displayName from 'component-lib/displayName';
import { FormattedMessage } from 'component-utilities/intl';
import styles from './AppHeader.scss';

export default function MenuItem({ id, onClick, action }) {
    return (
        <a
            role="presentation"
            data-action={kebabCase(action)}
            className={styles['dropdown-link']}
            onClick={onClick}
        >
            <FormattedMessage id={id} />
        </a>
    );
}

MenuItem.displayName = displayName('AppHeader/MenuItem');

MenuItem.propTypes = {
    id: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};
